<template>
    <div  class="absolute right-0 mt-0.5 w-[185px] rounded-xl bg-surface-level-0 shadow-[0px_0px_32px_0px_rgba(0,0,0,0.20)]  shadow  z-50"
        v-click-outside="handleClickOutside">
        <div class="py-1" role="menu" aria-orientation="vertical">
            <button :disabled="item.disabled" v-for="(item, index) in menuItems" :key="index"
                :class="item.className"
                class="w-full h-[44px] px-4 py-0.5 flex items-center gap-0.5 border-b border-border-light last:border-b-0 whitespace-nowrap"
                role="menuitem" @click.stop="$emit('click',item.action)">
                {{ item.label }}
            </button>
        </div>
    </div>
</template>
<script setup lang="ts">
import { ref } from 'vue';
import { MenuItem } from '@/models/MenuItem';
import { vClickOutside } from '@/directives/clickOutside';

interface Props {
    menuItems: MenuItem[];
}

defineProps<Props>();

const emit = defineEmits(["click","close"]);
const loading = ref(true);

setTimeout(() => {
    loading.value = false;
}, 0);

const handleClickOutside = () => {
    if (loading.value === false) {
        emit('close');
    }
};
</script>
